"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showSubmitterResult = exports.showSystemInfo = exports.showUserAlias = exports.punchSourceMap = void 0;
exports.punchSourceMap = {
    YonksPunchCollection: 'PunchAnywhere Clock',
    PunchAnywhere: 'PunchAnywhere Clock',
    AtoZTimeoffService: 'A to Z',
    WorkEventsUIStaticWebsite: 'Manager Console',
    TAAPunchServiceClient: 'Manager Console',
    MissedPunchCorrectionService: 'Associate Missed Punch',
    ['MPA Punch - Associate Initiated']: 'Associate Missed Punch',
    CSSorocoIntegration: 'System Generated Punch',
    MpcaAutoCorrection: 'System Generated Missed Punch',
    ['MPA Punch - Automated Correction']: 'System Generated Missed Punch',
    MyTimeUI: 'Manager Console',
    KronosClock: 'Kronos Clock',
    BoxerAipService: 'Associate Initiated Punch'
};
exports.showUserAlias = [
    'YonksPunchCollection',
    'PunchAnywhere',
    'AtoZTimeoffService',
    'MissedPunchCorrectionService',
    'MPA Punch - Associate Initiated',
    'BoxerAipService'
];
exports.showSystemInfo = [
    'CSSorocoIntegration',
    'MpcaAutoCorrection',
    'MPA Punch - Automated Correction'
];
exports.showSubmitterResult = ['MyTimeUI', 'KronosClock'];
